import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import SupplierService from '../services/SupplierService';
import { isEmpty } from 'lodash';

const initialState = {
  data: [],
  datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  submitLoading: false,
  isSuccess: false,

  isOpenSupplierDialog: false,
};

export const fetchSupplierList = createAsyncThunk(
  'supplier/fetchSupplierList',
  async ({ perPage, page, keyword }) => {
    try {
      const resp = await SupplierService.List({ perPage, page, keyword });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const createSupplier = createAsyncThunk('supplier/createSupplier', async (data, {rejectWithValue}) => {
  try {
    const resp = await SupplierService.Create(data);
    return resp;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateSupplier = createAsyncThunk('supplier/updateSupplier', async (payload, { rejectWithValue }) => {
  try {
    const resp = await SupplierService.Put(payload);
    return resp;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteSupplier = createAsyncThunk('supplier/deleteSupplier', async (id) => {
  try {
    const resp = await SupplierService.Delt(id);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const getAllSuppliers = createAsyncThunk(
  'supplier/all',
  async () => {
    try {
      const resp = await SupplierService.All();
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

const supplierSlice = createSlice({
  name: 'supplier',
  initialState: initialState,
  reducers: {
    openSupplierDialog: (state, action) => {
      state.isOpenSupplierDialog = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupplierList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchSupplierList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data.supplierList];
          state.pagination = action.payload?.data.data.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(fetchSupplierList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(createSupplier.pending, (state, action) => {
        state.submitLoading = true;
        state.isSuccess = false;
      })
      .addCase(createSupplier.fulfilled, (state, action) => {
        state.submitLoading = false;
        state.isSuccess = true;
        state.datas.unshift(action.payload.data.data);
        toast.success(action.payload?.data.message);
      })
      .addCase(createSupplier.rejected, (state, action) => {
        state.submitLoading = false;
        state.isSuccess = false;
        const errors = action.payload?.errors;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message);
        } else {
          state.formError = errors;
        }
      })
      .addCase(updateSupplier.pending, (state, action) => {
        state.isSuccess = false;
        state.submitLoading = true;
      })
      .addCase(updateSupplier.fulfilled, (state, action) => {
        const index = state.datas.findIndex(
          (client) => client.id === action.payload.data.data.id,
        );
        state.datas[index] = {
          ...state[index],
          ...action.payload.data.data,
        };
        toast.success(action.payload?.data.message);
        state.submitLoading = false;
        state.isSuccess = true;
      })
      .addCase(updateSupplier.rejected, (state, action) => {
        const errors = action.payload?.errors;
        state.submitLoading = false;
        state.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message);
        } else {
          state.formError = errors;
        }
      })
      .addCase(deleteSupplier.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(deleteSupplier.fulfilled, (state, action) => {
        const deletedId = action.meta.arg;
        state.datas = state.datas.filter(item => item.id !== deletedId);
        toast.success(action.payload?.data.message);
        state.submitLoading = false;
        state.isOpenSupplierDialog = false;
        state.pagination = {
          ...state.pagination,
          total: state.pagination.total > 0 ? state.pagination.total - 1 : 0,
        };
      })
      .addCase(deleteSupplier.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(getAllSuppliers.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllSuppliers.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data];
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(getAllSuppliers.rejected, (state, action) => {
        state.error = action.payload?.data.message;
        state.loading = false;
        toast.error(state.error);
      });
  },
});

const { reducer } = supplierSlice;

export const { openSupplierDialog } = supplierSlice.actions;

export const supplierSelector = (state) => state.supplier;

export default reducer;
